var _path, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLedNumberOfAreas(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFA700",
    fillOpacity: 0.2,
    d: "M0 0h36v36H0z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#led-number-of-areas_svg__clip0)",
    fill: "#FFA700"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.937 8H8.785A.771.771 0 008 8.785v6.126c0 .445.34.785.785.785s.786-.34.786-.785v-5.34h5.366c.445 0 .785-.34.785-.786A.771.771 0 0014.937 8zM14.911 26.403h-5.34v-5.34a.771.771 0 00-.786-.786.771.771 0 00-.785.786v6.125c0 .445.34.786.785.786h6.126c.445 0 .785-.34.785-.786a.771.771 0 00-.785-.785zM27.189 20.277a.771.771 0 00-.785.786v5.366h-5.34a.771.771 0 00-.786.786c0 .445.34.785.785.785h6.126c.445 0 .785-.34.785-.785v-6.152a.771.771 0 00-.785-.786zM27.215 8h-6.152a.771.771 0 00-.785.785c0 .445.34.786.785.786h5.367v5.366c0 .445.34.785.785.785s.785-.34.785-.785V8.785A.771.771 0 0027.215 8z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "led-number-of-areas_svg__clip0"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(8 8)",
    d: "M0 0h20v20H0z"
  })))));
}
export default SvgLedNumberOfAreas;